import { Navigate } from 'react-router-dom';
import { useStoreFront } from '../StoreFrontBuilder/context';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { slide4, slide5 } from '@/static/images';
import { useIntercom } from '@/hooks/useIntercom';

export default function StoryPreview() {
  const { iFrameKey } = useStoreFront();
  useIntercom(false);

  const vendorUsername = new URLSearchParams(window.location.search).get('vendor');
  const slideId = new URLSearchParams(window.location.search).get('id');

  if (!slideId || !vendorUsername) return <Navigate to={`/posts/feed`} />;

  const slide = getSlideById(parseInt(slideId, 10), vendorUsername, iFrameKey);

  if (!slide) {
    return <div className="h-screen flex items-center justify-center">Slide not found</div>;
  }

  return <>{slide.content}</>;
}

function getSlideById(id: number, vendorUsername: string, iFrameKey: number) {
  const NIGHTWING_URL = import.meta.env.VITE_NIGHTWING_URL || 'https://agora.red';
  const slides = [
    {
      id: 1,
      title: 'Página 1',
      content: (
        <div className="bg-white w-[1080px] h-[1920px] flex items-center flex-col gap-12 justify-center">
          <div className="flex items-center justify-center w-20 h-20 text-5xl font-bold text-white bg-black rounded-full">
            <span className="flex items-center justify-center w-full h-full leading-none">1</span>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">
            Ingresá a <br /> nuestra página
          </h1>
          <p className="text-5xl mb-2">agora.red/{vendorUsername}</p>
          <div className="relative w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-full flex items-start justify-center">
                <iframe
                  src={`${NIGHTWING_URL}/iframe/${vendorUsername}?isPreview=true&mobile=true`}
                  key={iFrameKey}
                  style={{
                    width: '390px',
                    height: '844px',
                    transform: 'scale(1.34)',
                    transformOrigin: 'top',
                    overflow: 'hidden',
                    pointerEvents: 'none'
                  }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 2,
      title: 'Página 2',
      content: (
        <div className="bg-white w-[1080px] h-[1920px] flex items-center flex-col gap-16 justify-center">
          <div className="flex items-center justify-center w-20 h-20 text-5xl font-bold text-white bg-black rounded-full">
            <span className="flex items-center justify-center w-full h-full leading-none">2</span>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">
            Seleccioná el servicio <br />
            que quieras realizarte
          </h1>
          <div className="relative w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-full flex items-start justify-center">
                <iframe
                  src={`${NIGHTWING_URL}/${vendorUsername}/reservar?isPreview=true&mobile=true`}
                  key={iFrameKey}
                  style={{
                    width: '390px',
                    height: '844px',
                    transform: 'scale(1.34)',
                    transformOrigin: 'top',
                    overflow: 'hidden',
                    pointerEvents: 'none'
                  }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 3,
      title: 'Página 3',
      content: (
        <div className="bg-white w-[1080px] h-[1920px] flex items-center flex-col gap-16 justify-center">
          <div className="flex items-center justify-center w-20 h-20 text-5xl font-bold text-white bg-black rounded-full">
            <span className="flex items-center justify-center w-full h-full leading-none">3</span>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">
            Seleccioná la fecha y <br /> hora del turno
          </h1>
          <div className="relative w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <img src={slide4} alt="slide4" className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      )
    },
    {
      id: 4,
      title: 'Página 4',
      content: (
        <div className="bg-white w-[1080px] h-[1920px] flex items-center flex-col gap-16 justify-center">
          <div className="flex items-center justify-center w-20 h-20 text-5xl font-bold text-white bg-black rounded-full">
            <span className="flex items-center justify-center w-full h-full leading-none">4</span>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">
            Completá tus datos <br /> personales
          </h1>
          <div className="relative w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <img src={slide5} alt="slide5" className="w-full h-full object-cover object-center" />
            </div>
          </div>
        </div>
      )
    },
    {
      id: 5,
      title: 'Página 5',
      content: (
        <div className="bg-white w-[1080px] h-[1920px] flex items-center flex-col gap-16 justify-center">
          <div className="flex items-center justify-center w-20 h-20 text-5xl font-bold text-white bg-black rounded-full">
            <span className="flex items-center justify-center w-full h-full leading-none">5</span>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">¡Y listo!</h1>
          <div className="relative w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <div className="bg-green-500 flex flex-col gap-8 items-center justify-center w-full h-full">
                <FontAwesomeIcon icon={faCheck} className="text-white" size="9x" />
                <span className="text-white text-4xl my-2 font-medium">¡Reserva confirmada!</span>
                <div className="flex items-center justify-center rounded-full py-2 px-4 bg-white text-green-500 text-2xl">
                  Ver reservas
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 6,
      title: 'Página 6',
      content: (
        <div className="bg-white relative w-[1080px] h-[1920px] flex items-center flex-col gap-16 justify-center">
          <div className="absolute left-[200px] top-[400px]">
            <svg
              width="120"
              height="130"
              viewBox="0 0 120 130"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <rect width="120" height="130" fill="url(#pattern0_3_3)" />
              <defs>
                <pattern id="pattern0_3_3" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlinkHref="#image0_3_3" transform="scale(0.00833333 0.00769231)" />
                </pattern>
                <image
                  id="image0_3_3"
                  width="120"
                  height="130"
                  preserveAspectRatio="none"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </div>
          <h1 className="text-6xl leading-snug font-medium text-center">
            ¡Reservá ahora desde <br /> nuestra página!
          </h1>
          <div className="relative mt-40 w-1/2 h-3/5 bg-gray-300 rounded-3xl overflow-hidden border-8 shadow-md">
            {/* Pantalla */}
            <div className="relative h-full w-full bg-gray-200 rounded-2xl overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-full flex items-start justify-center">
                <iframe
                  src={`${NIGHTWING_URL}/iframe/${vendorUsername}?isPreview=true&mobile=true`}
                  key={iFrameKey}
                  style={{
                    width: '390px',
                    height: '844px',
                    transform: 'scale(1.34)',
                    transformOrigin: 'top',
                    overflow: 'hidden',
                    pointerEvents: 'none'
                  }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )
    }
  ];

  return slides.find((slide) => slide.id === id);
}
